export default "__VITE_ASSET__37a71dad__"